import React from 'react'
import { Form } from 'react-bootstrap'

interface ExportOptionsPanelProps {
  datasetSplit: 'training' | 'validation'
  setDatasetSplit: (v: 'training' | 'validation') => void
  uploadAsUnannotated: boolean
  setUploadAsUnannotated: (v: boolean) => void
  imageSize: number
  setImageSize: (v: number) => void
  selectedCount: number
  isOBBProject?: boolean
  rotateLongSideVertical?: boolean
  setRotateLongSideVertical?: (v: boolean) => void
}

const ExportOptionsPanel: React.FC<ExportOptionsPanelProps> = ({
  datasetSplit,
  setDatasetSplit,
  uploadAsUnannotated,
  setUploadAsUnannotated,
  imageSize,
  setImageSize,
  selectedCount,
  isOBBProject = false,
  rotateLongSideVertical = false,
  setRotateLongSideVertical,
}) => {
  return (
    <>
      <Form.Group className="mb-3">
        <Form.Label className="text-light">Export options</Form.Label>
        <div className="d-flex flex-column gap-2">
          <div className="d-flex align-items-center gap-3">
            <Form.Label className="mb-0 text-light">Dataset split</Form.Label>
            <div className="d-flex align-items-center gap-3">
              <Form.Check
                type="radio"
                name="datasetSplit"
                id="datasetSplitTraining"
                label={<span className="text-light">Training</span>}
                checked={datasetSplit === 'training'}
                onChange={() => setDatasetSplit('training')}
              />
              <Form.Check
                type="radio"
                name="datasetSplit"
                id="datasetSplitValidation"
                label={<span className="text-light">Validation</span>}
                checked={datasetSplit === 'validation'}
                onChange={() => setDatasetSplit('validation')}
              />
            </div>
          </div>
          <Form.Check
            type="checkbox"
            label={<span className="text-light">Upload as unannotated (no labels)</span>}
            checked={uploadAsUnannotated}
            onChange={(e) => setUploadAsUnannotated(e.target.checked)}
          />
          {isOBBProject && setRotateLongSideVertical && (
            <Form.Check
              type="checkbox"
              label={<span className="text-light">Rotate snippets (align long side vertical)</span>}
              checked={rotateLongSideVertical}
              onChange={(e) => setRotateLongSideVertical(e.target.checked)}
            />
          )}
          <div className="d-flex align-items-center gap-2">
            <Form.Label className="mb-0 text-light">PNG size</Form.Label>
            <Form.Select
              className="bg-dark text-light border-secondary"
              value={imageSize}
              onChange={(e) => setImageSize(parseInt(e.target.value, 10))}
              style={{ maxWidth: '140px' }}
            >
              <option value={256}>256</option>
              <option value={512}>512</option>
              <option value={640}>640</option>
            </Form.Select>
          </div>
        </div>
      </Form.Group>
      <div className="text-secondary small">
        {selectedCount} snippet{selectedCount !== 1 ? 's' : ''} selected
      </div>
    </>
  )
}

export default ExportOptionsPanel
